import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  TravelBookingRequest,
  TravelBookingStatus,
  TravelCategory,
  TravelConfig,
  TravelPackage,
  TravelLocation,
  TravelService,
  TravelQuote,
} from "../models/Experience/ExperienceModels";
import { StoreDomain } from "../models/Experience/ExperienceSharedModels";

class TravelApi extends BaseApi {
  public config = BaseApi.createEndpoint<TravelConfig, null>(HttpMethodEnum.GET, "/travel/config");
  public updateConfig = BaseApi.createEndpoint<TravelConfig, { config: Partial<TravelConfig> }>(
    HttpMethodEnum.PUT,
    "/travel/config",
  );
  public publish = BaseApi.createEndpoint<TravelConfig, { config: Partial<TravelConfig> }>(
    HttpMethodEnum.POST,
    "/travel/publish",
  );
  public previewToken = BaseApi.createEndpoint<{ token: string; whatsappNumber: string }, { hostname: string }>(
    HttpMethodEnum.POST,
    "/travel/preview-token",
  );
  public categories = BaseApi.createEndpoint<TravelCategory[], null>(HttpMethodEnum.GET, "/travel/categories");
  public createCategory = BaseApi.createEndpoint<TravelCategory, { category: Partial<TravelCategory> }>(
    HttpMethodEnum.POST,
    "/travel/categories",
  );
  public updateCategory = (id: string) =>
    BaseApi.createEndpoint<TravelCategory, { category: Partial<TravelCategory> }>(
      HttpMethodEnum.PUT,
      `/travel/categories/${id}`,
    );
  public deleteCategory = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/travel/categories/${id}`);
  public locations = BaseApi.createEndpoint<TravelLocation[], null>(HttpMethodEnum.GET, "/travel/locations");
  public createLocation = BaseApi.createEndpoint<TravelLocation, { location: Partial<TravelLocation> }>(HttpMethodEnum.POST, "/travel/locations");
  public updateLocation = (id: string) => BaseApi.createEndpoint<TravelLocation, { location: Partial<TravelLocation> }>(HttpMethodEnum.PUT, `/travel/locations/${id}`);
  public deleteLocation = (id: string) => BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/travel/locations/${id}`);
  public services = BaseApi.createEndpoint<TravelService[], null>(HttpMethodEnum.GET, "/travel/services");
  public createService = BaseApi.createEndpoint<TravelService, { service: Partial<TravelService> }>(HttpMethodEnum.POST, "/travel/services");
  public updateService = (id: string) => BaseApi.createEndpoint<TravelService, { service: Partial<TravelService> }>(HttpMethodEnum.PUT, `/travel/services/${id}`);
  public deleteService = (id: string) => BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/travel/services/${id}`);
  public packages = BaseApi.createEndpoint<TravelPackage[], null>(HttpMethodEnum.GET, "/travel/packages");
  public createPackage = BaseApi.createEndpoint<TravelPackage, { travelPackage: Partial<TravelPackage> }>(
    HttpMethodEnum.POST,
    "/travel/packages",
  );
  public updatePackage = (id: string) =>
    BaseApi.createEndpoint<TravelPackage, { travelPackage: Partial<TravelPackage> }>(
      HttpMethodEnum.PUT,
      `/travel/packages/${id}`,
    );
  public deletePackage = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/travel/packages/${id}`);
  public domains = BaseApi.createEndpoint<StoreDomain[], null>(HttpMethodEnum.GET, "/travel/domains");
  public addDomain = BaseApi.createEndpoint<StoreDomain, { hostname: string }>(
    HttpMethodEnum.POST,
    "/travel/domains",
  );
  public verifyDomain = (hostname: string) =>
    BaseApi.createEndpoint<StoreDomain, null>(
      HttpMethodEnum.POST,
      `/travel/domains/${encodeURIComponent(hostname)}/verify`,
    );
  public bookings = BaseApi.createEndpoint<TravelBookingRequest[], null>(HttpMethodEnum.GET, "/travel/bookings");
  public updateBookingStatus = (bookingId: string) =>
    BaseApi.createEndpoint<TravelBookingRequest, { status: TravelBookingStatus }>(
      HttpMethodEnum.PUT,
      `/travel/bookings/${bookingId}/status`,
    );
  public updateBookingQuote = (bookingId: string) =>
    BaseApi.createEndpoint<TravelBookingRequest, { quote: Partial<TravelQuote> }>(
      HttpMethodEnum.PUT,
      `/travel/bookings/${bookingId}/quote`,
    );
}

export const travelApi = new TravelApi();
